import { POSITION_MODELS } from './cardEnv';

let sessions = null;
let loadPromise = null;
let loadError = null;
let ortModule = null;

function modelBaseUrl() {
    const base = process.env.PUBLIC_URL || '';
    return `${base}/models`;
}

function ortWasmPath() {
    const base = process.env.PUBLIC_URL || '';
    return `${base}/ort/`;
}

export function getModelLoadError() {
    return loadError;
}

export function areModelsLoaded() {
    return sessions !== null;
}

export async function ensureDouzeroModels(onProgress) {
    if (sessions) return sessions;
    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
        loadError = null;
        ortModule = await import('onnxruntime-web');
        ortModule.env.wasm.wasmPaths = ortWasmPath();

        const loaded = {};
        for (let i = 0; i < POSITION_MODELS.length; i++) {
            const name = POSITION_MODELS[i];
            if (onProgress) onProgress(name, i, POSITION_MODELS.length);
            const url = `${modelBaseUrl()}/${name}.onnx`;
            try {
                loaded[name] = await ortModule.InferenceSession.create(url, {
                    executionProviders: ['wasm'],
                });
            } catch (err) {
                loadError = err;
                throw new Error(
                    `Failed to load ${name}.onnx. Copy ONNX files to public/models/ (see public/models/README.md). ${err.message}`,
                );
            }
        }
        sessions = loaded;
        return sessions;
    })();

    try {
        return await loadPromise;
    } catch (err) {
        loadPromise = null;
        throw err;
    }
}

export function getSessionForPosition(playerPosition) {
    if (!sessions) throw new Error('DouZero models not loaded');
    return sessions[POSITION_MODELS[playerPosition]];
}

export async function runInference(playerPosition, xBatch, zBatch, numLegal) {
    if (!ortModule) throw new Error('onnxruntime-web not loaded');
    const session = getSessionForPosition(playerPosition);
    const feeds = {
        z: new ortModule.Tensor('float32', zBatch, [numLegal, 5, 162]),
        x: new ortModule.Tensor('float32', xBatch, [numLegal, playerPosition === 0 ? 373 : 484]),
    };
    const output = await session.run(feeds);
    const y = output.y || output[Object.keys(output)[0]];
    return y.data;
}
